import React from "react";
import { GlobalStyle } from "./src/components/single/globalStyle/globalStyle.const";

export const shouldUpdateScroll = ({
	routerProps: { location },
	getSavedScrollPosition,
}) => {
	const currentPosition = getSavedScrollPosition(location);

	if (
		location.pathname === "/search/" ||
		location.pathname === "/pliki/" ||
		location.pathname === "/ciasteczka/" ||
		location.pathname === "/jak-rezerwowac/" ||
		location.pathname === "/regulamin/"
	) {
		return true;
	}

	setTimeout(() => {
		const [x, y] = currentPosition || [0, 0];
		window.scrollTo({ top: y, left: x, behavior: "instant" });
	}, 0);

	return false;
};

export const wrapPageElement = ({ element }) => {
	<>
		<GlobalStyle />
		{element}
	</>;
};
